<template>
<div class="pay">
<el-row>
  <el-col :span="16" :offset="4"><div class="pay_content">
<ul>
<li v-for="payLists in payList" :key="payLists.index" @click="payment(payLists.money)">
<img src="../assets/bottom/phototeam_1.jpg" alt="">
<p>{{payLists.content}}</p>
<p>{{payLists.dian}}枚点数</p>
<p>{{payLists.money}}元</p>
</li>

</ul>
</div></el-col>
</el-row>
<div class="zhifubao" ref="zhifubao">
<ul>
<li @click="alipay">支付宝支付</li>
<li @click="wxpay">微信支付</li>
<li><el-button type="danger" icon="el-icon-close" circle @click="quixiao"></el-button></li>
</ul>
</div>
</div>

</template>

<script>
export default {
  name:'pay',
  data () {
    return {
      context:[],//存储创建订单
      alipayUrl:'',//存储支付
      payList:[{
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'100',
        money:'100'
      },
      {
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'200',
        money:'200'
      },
      {
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'300',
        money:'300'
      },
      {
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'400',
        money:'400'
      },
      {
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'500',
        money:'500'
      },
      {
        img:'../assets/bottom/phototeam_1.jpg',
        content:'你正在购买快乐二进制的点数',
        dian:'1000',
        money:'1000'
      }
      ]
    }
  },
  methods: {
wxpay() {
  this.$message({
    type: 'info',
    message: '抱歉,现在还不支持微信'
  });
},
    //支付宝支付
    alipay() {
console.log('支付宝支付')
this.context
console.log(this.context)
if(!this.$cookie.get('token')) {
  this.$router.push('/login')
}else {
  let data = {
    order_id:this.context.order_id,
    token:this.$cookie.get('token')
  }
  this.$store.dispatch("GetAlipay",data).then((res) => {
    console.log(res)
    if(res.data.code == 0) {
      console.log(res.data.errmsg) //
      this.alipayUrl = res.data.alipay_url //存储
      window.location.href = res.data.alipay_url;
    }else {
      this.$message({
        type: 'info',
        message: '支付出现错误'
      });
    }

 })
    // alipay_url
}

    },
    //微信支付
    wx() {
      console.log('微信支付')
    },
    // 点击取消支付
    quixiao() {
console.log(this.$refs.zhifubao);
this.$refs.zhifubao.style.opacity = "0";
this.$refs.zhifubao.style.top = "0%";
    },
    // 点击付费
    payment(e) {
      this.open(e)
    },
    //
open(e) {
        this.$confirm('你在支付的金额为' + e + '元', '支付提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          let data = {
            "token": this.$cookie.get('token'),
            "total_amount": e
          };
          this.$store.dispatch("PostPay",data).then((res) => {
            console.log(res)
            if(res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '请选择支付方式'
              });
              this.context = res.data.context;
this.$refs.zhifubao.style.opacity = "1";
this.$refs.zhifubao.style.top = "50%";
              console.log()
            }else {
              this.$message({
                type: 'info',
                message: '支付失败'
              });
            }
          })
        }).catch(() => {
          console.log('用户取消支付')
        });
      }
  }
}
</script>

<style scoped lang="scss">
.pay {
  height: 12rem;
  width: 100%;
  background-color: #f5f8fa;
  .zhifubao {
    width: 400px;
    height: 400px;
    background-color: #f5f8fa;
    position: fixed;
    left: 50%;
    top: 0%;
    // display: none;
    margin-top: -200px;
    // z-index: -1;
    // margin-bottom: -200px;
    margin-left: -200px ;
    opacity: 0;
    transition: all 2s;
    border-radius: 20px;
    ul {
      width: 100%;
      height: 100%;
      position: relative;
      li {
        position: absolute;
      }
      li:first-of-type,li:nth-of-type(2) {
        width: 50%;
        height: 40px;
        // background-color: red;
        left: 25%;
        line-height: 40px;
        font-size: 20px;
        border-radius: 20px;
        color: #FFFFFF;
        // margin-left: -200px;
      }
      li:first-of-type{
         top: 30%;
         background-color: #409eff;
      }
      li:nth-of-type(2) {
        top: 50%;
        background-color: #67c23a;
      }
      li:last-of-type {
        right: 20px;
        top: 20px;
        width: 40px;
        height: 40px;
      }
    }
  }
  .pay_content {
    height: 10rem;
    background-color: #fff;
    margin-top: 1rem;
    overflow: hidden;
    border-radius: 15px;
    ul {
      width: 90%;
      height: 9rem;
      margin: 0.5rem auto;
      // background-color: red;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      li:hover {
        // background-color: red;
         border: 1px solid red;
         img {
           transform: scale(1.1);
         }
      }
      li {
        width: 30%;
        height: 4rem;
        transition: all 0.5s;
        overflow: hidden;
        // background-color: green;
        border: 1px solid #DCDCDC;
        border-radius: 0.1rem;
        img {
          width: 100%;
          transition: all 0.5s;
          height: 2.5rem;
          border-radius: 0.1rem 0.1rem 0rem 0rem;
        }
        p {
          font-weight: 600;
          font-size: 15px;
        }
        p:first-of-type {
          margin-top: 10px;
        }
        p:nth-of-type(2),p:last-of-type {
          color: red;
          // text-align: left;
        }
      }
    }
  }
}
</style>
